
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcPoiVessel as ObcPoiVesselElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-vessel/poi-vessel.js';
 
 
 

 
 export const ObcPoiVessel = createComponent({
   react: React,
   tagName: 'obc-poi-vessel',
   elementClass: ObcPoiVesselElement,
   events: {
     
     onObcPoiDataLayoutChange: 'obc-poi-data-layout-change' as EventName<CustomEvent<void>>,
   }
  });
 
 